// Pantallas de la app móvil (screen_view.payload.screen) agrupadas por módulo.
// Los nombres "Eight", "Nine", "Ten" vienen del drawer de la app (Colores, Números, Figuras).
const MODULE_SCREENS = {
  alphabet: ["AlabetoPageCover", "AlfabetoPageCover", "AlfabetoHome", "IndividualLetter", "SortableGrid"],
  sounds: ["SoundHome", "Simples", "SimplesDetail", "Compuestos", "CompuestosDetail", "Letters", "Exercises"],
  write: ["WritePageScreen", "WordTracingScreen"],
  words: ["WordsArchive", "WordsIndividual", "ReceivedWords"],
  complete: ["CompletarHome", "CompletarSilabas", "CompletarIndividual", "CompletarPalabras", "CompletarSonidos"],
  family: ["FamilyHome", "FamilyRegister", "FamilyMain", "FamilyIntro", "FamilyDetail", "FamilyTree", "FamilySisters"],
  colors: ["Eight"],
  math: ["Nine"],
  shapes: ["Ten", "Shapes"],
  read: ["ReadingScreen", "ReadingDetail", "ReadTexts", "QuestionsTexts", "ICanReadScreen1", "InferenceDetail"],
};

// Navegación pura (inicio, login, ajustes): no cuenta como práctica.
const NAV_SCREENS = new Set(["First", "Dashboard", "LoginScreen", "Login", "InitialScreen", "Settings", "UpdateParentalLock"]);

const SCREEN_MODULE = {};
Object.entries(MODULE_SCREENS).forEach(([mod, screens]) => screens.forEach((s) => { SCREEN_MODULE[s] = mod; }));

export const moduleOf = (screen) => (!screen || NAV_SCREENS.has(screen) ? null : SCREEN_MODULE[screen] || "other");

// Un hueco mayor entre dos eventos se toma como que dejó la app (no suma tiempo).
const IDLE_GAP_MS = 15 * 60 * 1000;

const localDayKey = (ms) => new Date(ms).toDateString();

/** Convierte la lista de eventos [{ name, tsMs, payload }] en un resumen legible por día y módulo. */
export function summarizeEvents(events, dayKey = localDayKey) {
  const sorted = (events || []).filter((e) => e && e.tsMs).sort((a, b) => a.tsMs - b.tsMs);
  const days = {};
  const modules = {};
  const highlights = [];
  let stars = 0;
  let starsTotal = null;
  let mastered = 0;
  let prevTs = null;

  for (const e of sorted) {
    const key = dayKey(e.tsMs);
    const d = (days[key] = days[key] || { date: e.tsMs, ms: 0, modules: new Set(), stars: 0, mastered: 0 });
    if (prevTs !== null && e.tsMs - prevTs <= IDLE_GAP_MS) d.ms += e.tsMs - prevTs;
    prevTs = e.tsMs;
    const p = e.payload || {};

    if (e.name === "screen_view") {
      const mod = moduleOf(p.screen);
      if (mod) {
        modules[mod] = (modules[mod] || 0) + 1;
        d.modules.add(mod);
      }
    } else if (e.name === "star_awarded") {
      const amount = Number(p.amount) || 0;
      stars += amount;
      d.stars += amount;
      if (p.total != null) starsTotal = Number(p.total);
    } else if (e.name === "item_mastered") {
      mastered++;
      d.mastered++;
    } else if (e.name === "family_member_added") {
      highlights.push({ type: "family", ts: e.tsMs, name: p.name, member: p.member });
    } else if (e.name === "word_added") {
      highlights.push({ type: "word", ts: e.tsMs, word: p.word });
    }
  }

  const dayList = Object.values(days)
    .map((d) => ({ date: d.date, minutes: Math.round(d.ms / 60000), modules: [...d.modules], stars: d.stars, mastered: d.mastered }))
    .sort((a, b) => b.date - a.date);

  return {
    lastActivity: sorted.length ? sorted[sorted.length - 1].tsMs : null,
    activeDays: dayList.length,
    minutes: dayList.reduce((sum, d) => sum + d.minutes, 0),
    stars,
    starsTotal,
    mastered,
    modules: Object.entries(modules).sort((a, b) => b[1] - a[1]),
    days: dayList,
    highlights: highlights.reverse(),
  };
}
